import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Components
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';

// Services
import authService from './services/authService';

// Styles
import GlobalStyles from './styles/GlobalStyles';

const App = () => {
  const [initializing, setInitializing] = useState(true);
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    // Handle URL callback from Okta if code parameter exists
    const handleAuthCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');
      
      if (error) {
        console.error('Authentication error from Okta:', error);
        setAuthError('Authentication failed');
      }
      
      if (code) {
        try {
          const result = await authService.handleCallback();
          if (result.success) {
            // Remove query parameters after successful auth
            window.history.replaceState({}, document.title, window.location.pathname);
          } else if (result.error) {
            setAuthError(result.error);
          }
        } catch (error) {
          console.error('Failed to handle authentication callback:', error);
          setAuthError('Authentication process failed');
        }
      }
      
      setInitializing(false);
    };

    handleAuthCallback();
    
    // Check URL path - if /login but user is authenticated, redirect to dashboard
    const checkLoginRedirect = () => {
      if (window.location.pathname === '/login' && authService.isAuthenticated()) {
        window.location.href = '/';
      }
    };
    
    checkLoginRedirect();
  }, []);

  if (initializing) {
    return (
      <div className="loading">
        <i className="fas fa-spinner fa-spin"></i>
        <span>Initializing application...</span>
      </div>
    );
  }

  return (
    <Router>
      <GlobalStyles />
      <Routes>
        <Route path="/login" element={<LoginPage error={authError} />} />
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/index.html" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App; 